import { useState } from "react";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import Collapse from "@mui/material/Collapse";
import Icon from "@mui/material/Icon";

const formatPercentage = (value) =>
    Number(value || 0).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

const HIDDEN_PERCENTAGE_LABEL = "****%";

function AssetTypeAllocationList({ data, isLoading, valuesHidden = false }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const [expandedItem, setExpandedItem] = useState(null);

    const handleToggleItem = (itemName) => {
        setExpandedItem((currentItem) => (currentItem === itemName ? null : itemName));
    };

    if (isLoading) {
        return (
            <MDBox px={2} pb={3}>
                <MDTypography variant="button" color="text">
                    Carregando posição...
                </MDTypography>
            </MDBox>
        );
    }

    if (!data?.length) {
        return (
            <MDBox px={2} pb={3}>
                <MDTypography variant="button" color="text">
                    Nenhuma posição encontrada
                </MDTypography>
            </MDBox>
        );
    }

    return (
        <MDBox component="ul" px={2} pb={2} pt={1} m={0} sx={{ listStyle: "none" }}>
            {data.map((item, index) => (
                <MDBox
                    component="li"
                    key={item.name}
                    sx={{
                        borderBottom:
                            index === data.length - 1
                                ? "none"
                                : `1px solid ${darkMode ? "rgba(255, 255, 255, 0.12)" : "rgba(52, 71, 103, 0.12)"}`,
                    }}
                >
                    <MDBox
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        py={2}
                        sx={{ cursor: "pointer", gap: 2 }}
                        onClick={() => handleToggleItem(item.name)}
                    >
                        <MDBox display="flex" alignItems="center" gap={1}>
                            <Icon fontSize="small" sx={{ color: darkMode ? "#ffffffcc" : "#344767" }}>
                                {expandedItem === item.name ? "expand_less" : "expand_more"}
                            </Icon>
                            <MDTypography variant="button" fontWeight="medium" color={darkMode ? "white" : "dark"}>
                                {item.name}
                            </MDTypography>
                        </MDBox>
                        <MDTypography variant="button" fontWeight="regular" color="text">
                            {valuesHidden ? HIDDEN_PERCENTAGE_LABEL : `${formatPercentage(item.value)}%`}
                        </MDTypography>
                    </MDBox>

                    <Collapse in={expandedItem === item.name} timeout="auto" unmountOnExit>
                        <MDBox px={4} pb={2}>
                            <MDTypography variant="caption" color="text" fontWeight="regular">
                                Ativos da categoria e percentual dentro dela
                            </MDTypography>
                            <MDBox component="ul" mt={1.5} mb={0} p={0} sx={{ listStyle: "none" }}>
                                {item.assets?.map((asset, assetIndex) => (
                                    <MDBox
                                        component="li"
                                        key={`${item.name}-${asset.name}`}
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        py={1.25}
                                        sx={{
                                            borderBottom:
                                                assetIndex === item.assets.length - 1
                                                    ? "none"
                                                    : `1px solid ${darkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(52, 71, 103, 0.08)"}`,
                                            gap: 2,
                                        }}
                                    >
                                        <MDTypography variant="button" fontWeight="regular" color="text">
                                            {asset.name}
                                        </MDTypography>
                                        <MDTypography variant="button" fontWeight="medium" color={darkMode ? "white" : "dark"}>
                                            {valuesHidden ? HIDDEN_PERCENTAGE_LABEL : `${formatPercentage(asset.value)}%`}
                                        </MDTypography>
                                    </MDBox>
                                ))}
                            </MDBox>
                        </MDBox>
                    </Collapse>
                </MDBox>
            ))}
        </MDBox>
    );
}

export default AssetTypeAllocationList;
